
const PrivacyPolicy = () => {
  const lastUpdate = "27/01/2026";

  const styles = {
    container: {
      backgroundColor: '#f9fafb',
      minHeight: '100vh',
      padding: '40px 20px',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#1f2937',
      lineHeight: '1.6',
    },
    card: {
      maxWidth: '800px',
      margin: '0 auto',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '40px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    },
    header: {
      borderBottom: '2px solid #e5e7eb',
      marginBottom: '30px',
      paddingBottom: '20px',
    },
    title: {
      color: '#059669', // Verde esmeralda para diferenciar Privacidad de Términos
      fontSize: '2rem',
      margin: '0 0 10px 0',
      fontWeight: '700',
    },
    metaData: {
      fontSize: '0.9rem',
      color: '#6b7280',
    },
    sectionTitle: {
      fontSize: '1.25rem',
      color: '#111827',
      marginTop: '30px',
      marginBottom: '15px',
      borderLeft: '4px solid #059669',
      paddingLeft: '15px',
      fontWeight: '600',
    },
    subTitle: {
      fontSize: '1.1rem',
      color: '#374151',
      marginTop: '20px',
      marginBottom: '10px',
      fontWeight: '600',
    },
    paragraph: {
      fontSize: '1rem',
      color: '#4b5563',
      marginBottom: '15px',
    },
    list: {
      paddingLeft: '20px',
      marginBottom: '20px',
    },
    listItem: {
      marginBottom: '8px',
      color: '#4b5563',
    },
    link: {
      color: '#059669',
      textDecoration: 'none',
      fontWeight: '500',
    },
    footer: {
      textAlign: 'center',
      marginTop: '40px',
      color: '#9ca3af',
      fontSize: '0.85rem',
    }
  };

  return (
    <div style={styles.container}>
      <main style={styles.card}>
        <header style={styles.header}>
          <h1 style={styles.title}>Política de Privacidad Vitaly App</h1>
          <div style={styles.metaData}>
            <p style={{ margin: '5px 0' }}><strong>Fecha de entrada en vigor:</strong> {lastUpdate}</p>
            <p style={{ margin: '5px 0' }}><strong>Última actualización:</strong> {lastUpdate}</p>
          </div>
        </header>

        <section>
          <h2 style={styles.sectionTitle}>1. Introducción</h2>
          <p style={styles.paragraph}>
            En Vitaly, respetamos y protegemos la privacidad de nuestros usuarios. Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos los datos personales cuando utilizas la aplicación móvil Vitaly y los servicios asociados.
          </p>

          <h2 style={styles.sectionTitle}>2. Responsable del tratamiento de datos</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Nombre comercial:</strong> Vitaly</li>
            <li style={styles.listItem}><strong>Sitio web:</strong> <a href="https://vitaly.care" style={styles.link}>https://vitaly.care</a></li>
            <li style={styles.listItem}><strong>Correo:</strong> <a href="mailto:vitalysuperapp@gmail.com" style={styles.link}>vitalysuperapp@gmail.com</a></li>
            <li style={styles.listItem}><strong>Dirección legal:</strong> Caracas, Venezuela</li>
          </ul>

          <h2 style={styles.sectionTitle}>3. Información que recopilamos</h2>
          
          <h3 style={styles.subTitle}>3.1 Datos personales</h3>
          <ul style={styles.list}>
            <li style={styles.listItem}>Nombre y apellido, correo electrónico y número de teléfono.</li>
            <li style={styles.listItem}>Fecha de nacimiento y datos de autenticación cifrados.</li>
          </ul>

          <h3 style={styles.subTitle}>3.2 Datos sensibles (salud)</h3>
          <p style={styles.paragraph}>
            La App puede tratar datos relacionados con la salud, tales como historial de consultas o información médica proporcionada voluntariamente, siempre bajo su consentimiento expreso.
          </p>

          <h2 style={styles.sectionTitle}>4. Finalidad del tratamiento</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>Crear y administrar tu cuenta de usuario.</li>
            <li style={styles.listItem}>Prestar y gestionar los servicios de bienestar y salud.</li>
            <li style={styles.listItem}>Facilitar comunicaciones y recordatorios importantes.</li>
            <li style={styles.listItem}>Cumplir con obligaciones legales y garantizar la seguridad.</li>
          </ul>

          <h2 style={styles.sectionTitle}>6. Compartición de datos con terceros</h2>
          <p style={styles.paragraph}>
            <strong>Vitaly no vende ni comercializa datos personales.</strong> Solo compartimos información con proveedores tecnológicos esenciales, profesionales de salud vinculados o autoridades competentes por ley.
          </p>

          <h2 style={styles.sectionTitle}>9. Derechos de los usuarios</h2>
          <p style={styles.paragraph}>Como usuario, tienes derecho a:</p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Acceder, rectificar o solicitar la eliminación de tus datos.</li>
            <li style={styles.listItem}>Retirar tu consentimiento en cualquier momento.</li>
          </ul>
          <p style={styles.paragraph}>
            Para ejercer estos derechos, contáctanos en: <a href="mailto:vitalysuperapp@gmail.com" style={styles.link}>vitalysuperapp@gmail.com</a>.
          </p>

          <h2 style={styles.sectionTitle}>12. Contacto</h2>
          <p style={styles.paragraph}>
            Si tienes dudas o solicitudes relacionadas con esta Política, puedes contactarnos a través de:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Correo:</strong> vitalysuperapp@gmail.com</li>
            <li style={styles.listItem}><strong>Web:</strong> https://vitaly.care</li>
          </ul>
        </section>
      </main>

      <footer style={styles.footer}>
        <p>&copy; 2026 Vitaly. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;